import {createContext,useContext,useState} from "react";

export const CategoryFilterContext = createContext();

export const CategoryFilterProvider = ({children}) => {
    const [selectedSubCategoryId,setSelectedSubCategoryId] = useState("");
  
    return (
        <CategoryFilterContext.Provider value={{selectedSubCategoryId,setSelectedSubCategoryId}}>
           {children}
        </CategoryFilterContext.Provider>
    )
};
export const useCategoryFilter = () => useContext(CategoryFilterContext);
